import { render, staticRenderFns } from "./videoup.vue?vue&type=template&id=382838ad&scoped=true&"
import script from "./videoup.vue?vue&type=script&lang=js&"
export * from "./videoup.vue?vue&type=script&lang=js&"
import style0 from "./videoup.vue?vue&type=style&index=0&id=382838ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382838ad",
  null
  
)

export default component.exports